'use client';

import React, { useCallback, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { classNames, isMp4 } from '../tools/helpers';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function GallerySlider2({
    imageActive = 0,
    images = [],
    className = '',
}) {
    const settings = {
        className: 'relative',
        dots: true,
        dotsClass:
            '!hidden sm:!flex absolute left-1/2 transform -translate-x-1/2 apart-dots w-[calc(50%-16px)] sm:w-[calc(50%-40px)] text-center items-center justify-center -mt-5 h-2 gap-2',
        autoplay: false,
        autoplaySpeed: 10000,
        infinite: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: false,
    };

    let sliderRef = useRef(null);

    const handleKeyDown = useCallback(
        (e) => {
            if ('slickNext' in sliderRef) {
                if (e.keyCode === 39) {
                    sliderRef.slickNext();
                } else if (e.keyCode === 37) {
                    sliderRef.slickPrev();
                }
            }
        },
        [images],
    );

    useEffect(() => {
        if (images.length > 1) {
            sliderRef.slickGoTo(imageActive, true);
        }
    }, [imageActive, images]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [images, handleKeyDown]);

    return (
        <div className={'overflow-hidden rounded-[20px]'}>
            {images.length > 1 && (
                <Slider
                    ref={(slider) => {
                        sliderRef = slider;
                    }}
                    {...settings}
                >
                    {images.map((image, index) =>
                        isMp4(image) ? (
                            <video
                                autoPlay
                                muted
                                loop
                                controls={false}
                                key={index}
                                className={classNames(
                                    'object-contain object-center rounded-2xl h-full w-full p-[1px]',
                                    className,
                                )}
                            >
                                <source src={image} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            <img
                                key={index}
                                src={image}
                                alt={''}
                                width={160}
                                height={160}
                                className={classNames(
                                    'object-contain object-center rounded-2xl h-full w-full p-[1px]',
                                    className,
                                )}
                            />
                        ),
                    )}
                </Slider>
            )}
            {images.length === 1 &&
                (isMp4(images[0]) ? (
                    <video
                        autoPlay
                        muted
                        loop
                        controls={false}
                        className={classNames(
                            'object-contain object-center rounded-2xl h-full w-full p-[1px]',
                            className,
                        )}
                    >
                        <source src={images[0]} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <img
                        src={images[0]}
                        alt={''}
                        width={160}
                        height={160}
                        className={classNames(
                            'object-contain object-center rounded-2xl h-full w-full p-[1px]',
                            className,
                        )}
                    />
                ))}
        </div>
    );
}
